/** Human-readable message from an axios-style API error.
 *
 * Backend `_bad(...)` responses carry a machine `error` code plus an optional
 * `detail`. The detail is what an operator can act on -- e.g. which variable a
 * rejected template link named -- so it wins when present.
 */
export function apiErrorMessage(e: unknown, fallback: string): string {
  const data = (e as { response?: { data?: { error?: unknown; detail?: unknown } } })
    ?.response?.data;
  if (typeof data?.detail === "string" && data.detail.trim()) return data.detail;
  if (typeof data?.error === "string" && data.error.trim()) return data.error;
  return fallback;
}
